import { reducer as formReducer } from 'redux-form/immutable'
import { fromJS, Map } from 'immutable'

import debug from 'utilities/debug'
import appReducer from 'views/App/reducer'

import { RESET_STATE } from './actions'
import { save, load } from './persist'

export const makePersistentReducer = (key, reducer, duration) => {
  const initialState = fromJS(load(key) || {})

  return (state = initialState, action) => {
    const newState = reducer(state, action)
    save(key, newState.toJS(), duration)
    return newState
  }
}

let reducers = new Map({
  app: appReducer,
  form: formReducer,
})

export const addReducer = (key, reducer) => {
  reducers = reducers.set(key, reducer)
  debug('Reducer injected: %o', key)
}

export const removeReducer = key => {
  reducers = reducers.delete(key)
  debug('Removed reducer: %o', key)
}

export const addPersistentReducer = (key, ...rest) => {
  addReducer(key, makePersistentReducer(key, ...rest))
}

export default (prevState = new Map(), action) =>
  reducers.reduce(
    (state, reducer, key) => state.set(key, reducer(state.get(key), action)),
    action.type === RESET_STATE ? new Map() : prevState,
  )



// WEBPACK FOOTER //
// ../source/state/reducers.js